import { Link } from 'gatsby'; /* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import MouseMove from './mouseMove';
import LoadingAnimation from './loadingAnimation';
import MenuToggle from './menuToggle';

const Header = ({ siteTitle }) => {
  return (
    <>
      <LoadingAnimation />
      <MouseMove />

      <header>
        <div className="inner">
          <Link className="logo" to="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 188.28 60.2"
              width="135"
            >
              <defs>
                <style>.cls-01(fill:#231815;)</style>
              </defs>
              <g>
                <g>
                  <path
                    className="cls-01"
                    d="M7.55,37.21h.14A4,4,0,0,1,11,38.91a2.29,2.29,0,0,0,1.89.89,2.15,2.15,0,0,0,1.37-.47,2.12,2.12,0,0,0,.95-1.84,2.35,2.35,0,0,0-.48-1.41,8.42,8.42,0,0,0-7-3.54H7.58A7.34,7.34,0,0,0,3,34.07a7.48,7.48,0,0,0-2.71,4A8,8,0,0,0,0,40.23,7.1,7.1,0,0,0,3.73,46.7L9.16,50a2.74,2.74,0,0,1,1.46,2.5,3,3,0,0,1-.83,2.15,2.79,2.79,0,0,1-2.11.87H7.54a4.06,4.06,0,0,1-3.37-1.65A2.24,2.24,0,0,0,2.32,53a2.26,2.26,0,0,0-1.42.48A2.22,2.22,0,0,0,0,55.29,2.28,2.28,0,0,0,.47,56.7a8.5,8.5,0,0,0,7.06,3.5h.14a7.47,7.47,0,0,0,4.59-1.54,7.18,7.18,0,0,0,2.7-4,8,8,0,0,0,.29-2.12,7.1,7.1,0,0,0-3.69-6.46L6.09,42.72a2.71,2.71,0,0,1-1.46-2.5,3,3,0,0,1,.82-2.14A2.77,2.77,0,0,1,7.55,37.21Z"
                  />
                  <path
                    className="cls-01"
                    d="M28.27,11.28A2.32,2.32,0,0,0,26,13.6V36.43a2.22,2.22,0,0,0,.68,1.65,2.32,2.32,0,0,0,3.26,0,2.18,2.18,0,0,0,.68-1.65V13.6a2.32,2.32,0,0,0-2.31-2.32Z"
                  />
                  <path
                    className="cls-01"
                    d="M28.27,5.57a2.68,2.68,0,0,0,2-.83,2.67,2.67,0,0,0,.83-1.95,2.68,2.68,0,0,0-.83-2,2.8,2.8,0,0,0-3.92,0,2.67,2.67,0,0,0-.82,2,2.66,2.66,0,0,0,.82,2A2.69,2.69,0,0,0,28.27,5.57Z"
                  />
                  <path
                    className="cls-01"
                    d="M45.22,24.11a2.26,2.26,0,0,0-1.66-.68,2.34,2.34,0,0,0-2.31,2.31V51.07a9.71,9.71,0,0,0,4.67,8.65,2.29,2.29,0,0,0,1.28.38,2.32,2.32,0,0,0,1.27-4.25,5.41,5.41,0,0,1-2.59-4.78V25.74A2.27,2.27,0,0,0,45.22,24.11Z"
                  />
                  <path
                    className="cls-01"
                    d="M64.85,48.73H75.57A2.19,2.19,0,0,0,77.22,48a2.3,2.3,0,0,0,.66-1.67V41.46a8.61,8.61,0,0,0-2.6-6.3A8.5,8.5,0,0,0,69,32.54h-.18a8.5,8.5,0,0,0-6.28,2.62,8.61,8.61,0,0,0-2.6,6.3v9.86a8.88,8.88,0,0,0,8.88,8.88H69a8.7,8.7,0,0,0,4.56-1.26,8.44,8.44,0,0,0,3.23-3.37,2.32,2.32,0,0,0,.29-1.13,2.27,2.27,0,0,0-.67-1.63,2.19,2.19,0,0,0-1.65-.69,2.16,2.16,0,0,0-2,1.23A4,4,0,0,1,69,55.57h-.18a4.27,4.27,0,0,1-4.25-4.25V49C64.57,48.81,64.66,48.73,64.85,48.73Zm-.28-7.24a4.16,4.16,0,0,1,1.25-3.07,4.06,4.06,0,0,1,3-1.26H69a4.06,4.06,0,0,1,3,1.26,4.16,4.16,0,0,1,1.25,3.07v2.37c0,.16-.09.24-.28.24H64.85c-.19,0-.28-.08-.28-.24Z"
                  />
                  <path
                    className="cls-01"
                    d="M102.39,59.27A2.18,2.18,0,0,0,104,60a2.23,2.23,0,0,0,1.66-.69,2.28,2.28,0,0,0,.68-1.67V41.46a8.95,8.95,0,0,0-8.92-8.92h-.19A8.51,8.51,0,0,0,91,35.16a8.61,8.61,0,0,0-2.59,6.3V57.6a2.3,2.3,0,0,0,3.94,1.67A2.28,2.28,0,0,0,93,57.6V41.46a4.28,4.28,0,0,1,4.27-4.3h.19a4.27,4.27,0,0,1,4.27,4.3V57.6A2.28,2.28,0,0,0,102.39,59.27Z"
                  />
                  <path
                    className="cls-01"
                    d="M122.6,38.41a4.13,4.13,0,0,1,3-1.25h.19a4,4,0,0,1,3.74,2.22,2.19,2.19,0,0,0,2,1.23,2.34,2.34,0,0,0,2.32-2.32,2.34,2.34,0,0,0-.28-1.13,8.92,8.92,0,0,0-3.28-3.37,8.6,8.6,0,0,0-4.51-1.25h-.19a8.95,8.95,0,0,0-8.92,8.92v9.86a8.53,8.53,0,0,0,2.62,6.28,8.65,8.65,0,0,0,6.3,2.6h.19a8.93,8.93,0,0,0,7.84-4.68,2.18,2.18,0,0,0,.28-1.08,2.34,2.34,0,0,0-2.37-2.36,2.2,2.2,0,0,0-2,1.22,4,4,0,0,1-3.74,2.27h-.19a4.27,4.27,0,0,1-4.26-4.25V41.46A4.17,4.17,0,0,1,122.6,38.41Z"
                  />
                  <path
                    className="cls-01"
                    d="M149.29,48.73H160a2.23,2.23,0,0,0,1.66-.69,2.3,2.3,0,0,0,.66-1.67V41.46a8.61,8.61,0,0,0-2.6-6.3,8.5,8.5,0,0,0-6.28-2.62h-.18A8.5,8.5,0,0,0,147,35.16a8.61,8.61,0,0,0-2.6,6.3v9.86a8.88,8.88,0,0,0,8.88,8.88h.18A8.7,8.7,0,0,0,158,58.94a8.44,8.44,0,0,0,3.23-3.37,2.31,2.31,0,0,0,.28-1.13,2.26,2.26,0,0,0-.66-1.63,2.19,2.19,0,0,0-1.65-.69,2.16,2.16,0,0,0-2,1.23,4,4,0,0,1-3.73,2.22h-.18A4.27,4.27,0,0,1,149,51.32V49C149,48.81,149.1,48.73,149.29,48.73ZM149,41.49a4.16,4.16,0,0,1,1.25-3.07,4.06,4.06,0,0,1,3-1.26h.18a4.06,4.06,0,0,1,3,1.26,4.2,4.2,0,0,1,1.25,3.07v2.37c0,.16-.09.24-.28.24h-8.12c-.19,0-.28-.08-.28-.24Z"
                  />
                  <path
                    className="cls-01"
                    d="M176.7,59.44a2.23,2.23,0,0,0,.67-1.66V42.52a5.26,5.26,0,0,1,5.18-5.26,4.29,4.29,0,0,1,1.8.39l.81.28a2.19,2.19,0,0,0,.75.13,2.29,2.29,0,0,0,1.68-.69,2.19,2.19,0,0,0,.69-1.62,2.11,2.11,0,0,0-1.56-2.18l-.8-.29a8.79,8.79,0,0,0-3.31-.65,9.6,9.6,0,0,0-5.66,1.8,9.36,9.36,0,0,0-4.2,8.1V57.78A2.27,2.27,0,0,0,175,60.1,2.31,2.31,0,0,0,176.7,59.44Z"
                  />
                </g>
              </g>
            </svg>
          </Link>
          <nav>
            <ul className="ec__area">
              <li>
                {/* <Link
                  aria-label="login"
                  to="https://store.silencer.inc/account/login"
                >
                  Login
                </Link> */}
                <a href="https://store.silencer.inc/">Store</a>
              </li>
              {/* <li> */}
              {/* <a href="#">Cart(0)</a> */}
              {/* <Link aria-label="cart" to="/cart"> */}
              {/* {quantity > 0 ? (
                    <>
                      Cart({quantity})<span className="cartAdded"></span>
                    </>
                  ) : (
                    <>Cart(0)</>
                  )} */}
              {/* {quantity > 0 ? <>cart({quantity})</> : <>cart(0)</>} */}
              {/* </Link> */}
              {/* </li> */}
            </ul>
            <MenuToggle />
          </nav>
        </div>
      </header>
    </>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
